import { useEffect, useState } from 'react';
import '../styles/PreLoader.css';

const HOLD_MS = 500;
const OPEN_DURATION_MS = 1100;

const PreLoader = ({ onFinish }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const openTimer = setTimeout(() => setOpen(true), HOLD_MS);
        const finishTimer = setTimeout(onFinish, HOLD_MS + OPEN_DURATION_MS);
        return () => {
            clearTimeout(openTimer);
            clearTimeout(finishTimer);
        };
    }, [onFinish]);

    return (
        <div className="preloader">
            <div className={`curtain curtain-left${open ? ' curtain-open' : ''}`} />
            <div className={`curtain curtain-right${open ? ' curtain-open' : ''}`} />
        </div>
    );
};

export default PreLoader;
